import { create } from 'zustand';
import { cruiseListRequest } from '../api';

export const useSearchTrackingStore = create<{
  search: null | cruiseListRequest;
  setSearch: (search: cruiseListRequest | null) => void;
}>((set) => ({
  search: null,
  setSearch: (search: cruiseListRequest | null) => set(() => ({ search })),
}));
